const ROTULOS: { [chave: string]: string } = {
  C: "Crédito",
  CA: "Crédito à vista",
  CP: "Crédito parcelado",
  D: "Débito",
  DA: "Débito",
  DP: "Débito",
  T: "Voucher",
  TA: "Voucher",
  TP: "Voucher",
};

const chave = (bruta: string) => bruta.replace(/[\s.]/g, "").toUpperCase();

export const rotuloModalidade = (bruta: string): string => {
  if (!bruta) {
    return bruta;
  }
  return ROTULOS[chave(bruta)] || bruta;
};
